module.exports = __webpack_public_path__ + "static/media/square-eye.f9bbbeae.svg";